import { ActionMap } from "@context/types/index";
import { IOptions } from "@components/form/Select/interface";

export enum TypesData {
  RefreshData = "REFRESH_DATA",
  ResetData = "RESET_DATA",
}

export interface IData {
  name: string;
  lastname: string;
  docType: IOptions | "";
  document: string;
  minorityId: IOptions | "";
  birthday: string;
  epsId: IOptions | "";
  areas: string[];
}
export type DataPayload = {
  [TypesData.RefreshData]: IData;
  [TypesData.ResetData]: undefined;
};

export type DataActions = ActionMap<DataPayload>[keyof ActionMap<DataPayload>];
